"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataTableCheckbox = void 0;
var react_1 = __importStar(require("react"));
var Checkbox_1 = __importDefault(require("@material-ui/core/Checkbox"));
var TableCell_1 = __importDefault(require("@material-ui/core/TableCell"));
exports.DataTableCheckbox = react_1.default.memo(function (_a) {
    var checkboxClicked = _a.checkboxClicked, id = _a.id, selectedAll = _a.selectedAll, filterString = _a.filterString, nRows = _a.nRows;
    var _b = react_1.useState(false), selected = _b[0], setSelected = _b[1];
    var prevSelectedAll = react_1.useRef(false);
    var prevFilterString = react_1.useRef('');
    var prevNRows = react_1.useRef(0);
    var clicked = function () {
        setSelected(function (prev) { return !prev; });
        checkboxClicked(id);
    };
    react_1.useEffect(function () {
        if (!prevSelectedAll.current && selectedAll && !selected) {
            setSelected(true);
        }
        else if (prevSelectedAll.current && !selectedAll && selected) {
            setSelected(false);
        }
        if (!prevSelectedAll.current && selectedAll) {
            prevSelectedAll.current = true;
        }
        else if (prevSelectedAll && !selectedAll) {
            prevSelectedAll.current = false;
        }
    }, [selectedAll, selected]);
    react_1.useEffect(function () {
        if (prevNRows.current !== nRows) {
            if (selected) {
                checkboxClicked(id);
            }
            setSelected(false);
            prevNRows.current = nRows !== null && nRows !== void 0 ? nRows : 0;
        }
    }, [nRows, checkboxClicked, id, selected]);
    react_1.useEffect(function () {
        if (prevFilterString.current !== filterString) {
            if (selected) {
                checkboxClicked(id);
            }
            setSelected(false);
            prevFilterString.current = filterString !== null && filterString !== void 0 ? filterString : '';
        }
    }, [filterString, checkboxClicked, id, selected]);
    return (react_1.default.createElement(TableCell_1.default, { padding: "checkbox" },
        react_1.default.createElement(Checkbox_1.default, { onClick: clicked, checked: selected })));
});
exports.DataTableCheckbox.displayName = 'DataTableCheckbox';
exports.default = exports.DataTableCheckbox;
//# sourceMappingURL=DataTableCheckbox.js.map